import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import NotificationApi from '../notification-base';
import Content from './content';
var defaultStyle = {};
var defaultDuration = 3000;
var defaultClosable = false;
var defaultOffset = '40px';
var defaultSuffixCls = 'message';
var defaultPlacement = 'message';
var defaultType = 'info';
var messageKey = 1;
var messageElement = null;
function isArgsProps(content) {
  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
}
var getNotificationProps = function getNotificationProps(args) {
  var _args$duration = args.duration,
    duration = _args$duration === void 0 ? defaultDuration : _args$duration,
    key = args.key,
    className = args.className,
    _args$style = args.style,
    style = _args$style === void 0 ? defaultStyle : _args$style,
    _args$type = args.type,
    type = _args$type === void 0 ? defaultType : _args$type,
    onClose = args.onClose,
    _args$closable = args.closable,
    closable = _args$closable === void 0 ? defaultClosable : _args$closable,
    content = args.content,
    icon = args.icon,
    closeNode = args.closeNode;
  // const placeStyle = getPlacementStyle(placement)
  // const element = renderView(args)
  var contentClose = function contentClose() {
    onClose && onClose(key);
    NotificationApi.destroy(key);
  };
  var contentProps = {
    type: type,
    icon: icon,
    closeNode: closeNode,
    content: content,
    closable: closable,
    suffixCls: defaultSuffixCls,
    contentClose: contentClose
  };
  return {
    duration: duration,
    key: key,
    className: className,
    style: style,
    type: type,
    closable: closable,
    onClose: onClose,
    placement: defaultPlacement,
    content: /*#__PURE__*/React.createElement(Content, _extends({}, contentProps)),
    suffixCls: defaultSuffixCls
  };
};
var getNotificationHTMLElement = function getNotificationHTMLElement() {
  var prefixCls = 'kd';
  var suffix = "".concat(prefixCls, "-message");
  var htmlElement = document.querySelector("#".concat(suffix));
  if (!htmlElement) {
    htmlElement = document.createElement('div');
    htmlElement.id = suffix;
    htmlElement.className = "".concat(suffix, "-box");
    htmlElement.style.top = defaultOffset;
    document.body.appendChild(htmlElement);
  }
  return htmlElement;
};
var notice = function notice(args) {
  var key = args.key || messageKey++;
  var props = getNotificationProps(_extends(_extends({}, args), {
    key: key
  }));
  var el;
  if (messageElement) {
    el = messageElement;
  } else {
    el = getNotificationHTMLElement();
  }
  NotificationApi.add(props, el);
};
var Message = {
  open: notice,
  destroy: function destroy(key) {
    NotificationApi.destroy(key);
  }
};
['success', 'warning', 'error', 'info'].forEach(function (type) {
  Message[type] = function (content, duration, onClose) {
    if (isArgsProps(content)) {
      return Message.open(_extends(_extends({}, content), {
        type: type
      }));
    }
    if (typeof duration === 'function') {
      onClose = duration;
      duration = undefined;
    }
    return Message.open({
      content: content,
      duration: duration,
      type: type,
      onClose: onClose
    });
  };
});
export default Message;